import type { Components } from '@mui/material/styles';

export default function MuiGrid(): Components['MuiGrid'] {
  return {};
}
